module.exports = __webpack_public_path__ + "static/media/bell.626dc15a.png";